import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { AppState } from 'src/app/core/app.state';
import { LocalStorageService } from 'src/app/shared/localstorage.service';
import {  parseSegmentFilterRequest, refillSegmentFilter } from 'src/app/shared/utils/helpers';
import { ISegmentFilter } from '../../models/segment.model';
import { ILocation } from 'src/app/features/customers/models/customers.models';
import { FetchAllLocations } from 'src/app/features/customers/store/customers.actions';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-filter-segment',
  templateUrl: './filter-segment.component.html',
  styleUrls: ['./filter-segment.component.scss']
})
export class FilterSegmentComponent implements OnInit {
  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  currentFilter: Observable<ISegmentFilter> = this.store.select(
    (state) => state.segments.segmentFilterState.advanced
  );
  segmentFilters = LocalStorageService.get('segmentFilters');

  locations$ = this.store.select((state) => state.customers.allLocations);
  filteredlocations$ = this.locations$;
  locationsFilterKey: string = '';

  tags$ = this.store.select((state) => state.tags.allTags);
  filteredTags$ = this.tags$;
  tagsFilterKey: string = '';

  statuses: { label: string; value: string }[] = [
    { label: 'All', value: '' },
    { label: 'Published', value: 'published' },
    { label: 'Draft', value: 'draft' },
  ];

  hasVariants: { label: string; value: boolean | null }[] = [
    {
      label: 'All',
      value: null,
    },
    {
      label: 'With variants',
      value: true,
    },
    {
      label: 'Without variant',
      value: false,
    },
  ];

  selectedGroup = 'segment_info';

  filter: ISegmentFilter = refillSegmentFilter();
  filterName = '';
  toggleSaveFilterForm = false;
  filterNameControl = new FormControl('', Validators.required);

  constructor(
    public dialogRef: MatDialogRef<FilterSegmentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<AppState>
  ) { }

  ngOnInit(): void {
    this.currentFilter.subscribe((filter: ISegmentFilter) => {
      this.filter = refillSegmentFilter(filter);
    });

    this.store.dispatch(FetchAllLocations());

  }

  getFiltersCount(): number {
    return parseSegmentFilterRequest(this.filter)?.filters?.length || 0;
  }

  close(): void {
    this.dialogRef.close();
  }

  clearFilters(): void {
    this.filter = refillSegmentFilter();
    this.filterName = '';
  }

  filterLocations(): void {
    this.filteredlocations$ = this.locations$.pipe(
      map((locations) =>
        locations.filter(
          (location) =>
            location.name
              .toLocaleLowerCase()
              ?.includes(this.locationsFilterKey.toLocaleLowerCase()!) &&
            !this.filter?.advancedFilter?.locations?.find(
              (c) => c.id === location.id
            )
        )
      )
    );
  }

  selectLocation(location: ILocation): void {
    if (this.filter?.advancedFilter?.locations)
      this.filter?.advancedFilter?.locations?.push(location);
    this.locationsFilterKey = '';
    this.filterLocations();
  }


  getLocationsNames(): string {
    return (this.filter?.advancedFilter?.locations || [])
      .map((location) => location.name)
      .join(', ');
  }


  toggleSaveFilter(): void {
    this.toggleSaveFilterForm = !this.toggleSaveFilterForm;
  }

  save(): boolean | void {
    if(!this.filterNameControl.valid){
      this.filterNameControl.markAsTouched();
      return false
    }
    if (!this.segmentFilters?.filters)
      this.segmentFilters = {
        filters: [{ name: this.filterName, filter: this.filter }],
      };
    else {
      const filter = this.segmentFilters.filters?.find(
        (f: any) => f.name.toLowerCase() === this.filterName.toLowerCase()
      );
      if (filter)
        this.segmentFilters.filters = this.segmentFilters.filters?.map((f: any) => {
          if (f.name === this.filterName) return { name: this.filterName, filter: this.filter };
          return f;
        });
      else
        this.segmentFilters.filters.push({
          name: this.filterName,
          filter: this.filter,
        });
    }
    LocalStorageService.put('segmentFilters', this.segmentFilters);
    this.toggleSaveFilter();
  }

  setFilter(filter: any): void {
    if(filter){
      this.filterName = filter.name;
      this.filter = refillSegmentFilter(filter.filter);
    }
  }

  deleteFilter(filter: any): void {
    this.segmentFilters.filters = this.segmentFilters.filters?.filter(
      (f: any) => f.name !== filter.name
    );
    LocalStorageService.put('segmentFilters', this.segmentFilters);
  }

  apply(): void {
    this.dialogRef.close(this.filter );
  }
}
